import React, { useState } from 'react'
import ModalCustom from '../../../../components/modal/ModalCustom';
import InputTextField from '../../../../components/input/inputTextField';
import { ButtonOutlined, ButtonPrimary } from '../../../../components/button/ButtonCustoms';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { styled } from '@mui/material';
import { alertSuccess } from '../../../../components/alert/swal';
import { EmployeeApi } from '../../../../api/employee/employee.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const IconEye = styled(VisibilityOffOutlinedIcon)({
    transform: "rotate(-180deg)",
    cursor: "pointer",
    '&:hover': {
        opacity: 1
    }
})

type Props = {
    open: boolean;
    onClose: (status: boolean) => void;
    callback:()=>void;
}

const ModalEditPassword: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const { id} = useParams();
    const { open, onClose ,callback} = props;
    const dispatch = useDispatch();
    const [togglePassword, setTogglePassword] = useState<boolean>(false);
    const [confirmTogglePassword, setConfirmTogglePassword] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [formChangePassword, setFormChangePassword] = useState<{ password: string, confirmPassword: string }>({
        password: "",
        confirmPassword: ""
    })
    const handleChange = (name: string, value: string) => {
        setErrorMessage("");
        setFormChangePassword((prev) => ({ ...prev, [name]: value }));
    }
    const handleSubmit = async (id_employee:number) => {
        if (!formChangePassword.password) {
            return setErrorMessage(t("ระบุรหัสผ่านใหม่ที่ต้องการ"));
        } else if (!formChangePassword.confirmPassword) {
            return setErrorMessage(t('ระบุรหัสผ่านใหม่ที่ต้องการ'));
        } else if (formChangePassword.password !== formChangePassword.confirmPassword) {
            return setErrorMessage(t("รหัสผ่านไม่ตรงกัน"));
        }
        const body: {
            new_password: string;
            confirm_password: string;
        } = {
            new_password: formChangePassword.password,
            confirm_password: formChangePassword.confirmPassword
        }
        dispatch(setLoading());
        await EmployeeApi.resetPassword(id_employee,body).then((res) => {
            if (res.status < 300) {
                alertSuccess(t('แก้ไขรหัสผ่าน'), t('แก้ไขรหัสผ่าน เรียบร้อยแล้ว'), undefined, () => {
                    onClose(false);
                })
            }
        }).catch((error) => console.log(error))
            .finally(() => {
                callback();
            })

    }
    return (
        <ModalCustom
            title={t("แก้ไขรหัสผ่าน")}
            subTitle={t("กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน")}
            open={open}
            onClose={() => {
                onClose(false);
            }}
            component={
                <section className='grid grid-cols-12 gap-y-6'>
                    <article className='col-span-12'>
                        <InputTextField
                            value={formChangePassword.password}
                            helperText={errorMessage}
                            type={togglePassword ? 'text' : 'password'}
                            heading={t("รหัสผ่านใหม่")}
                            placeholder={t("ระบุรหัสผ่านใหม่")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('password', e.target.value)}
                            endAdornment={<IconEye onClick={() => setTogglePassword(!togglePassword)} sx={{ opacity: !togglePassword ? .3 : 1 }} />}
                        />
                    </article>
                    <article className='col-span-12'>
                        <InputTextField
                            value={formChangePassword.confirmPassword}
                            helperText={errorMessage}
                            type={confirmTogglePassword ? 'text' : 'password'}
                            placeholder={t("ยืนยันรหัสผ่านใหม่อีกครั้ง")}
                            heading={t("ยืนยันรหัสผ่านใหม่อีกครั้ง")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('confirmPassword', e.target.value)}
                            endAdornment={<IconEye onClick={() => setConfirmTogglePassword(!confirmTogglePassword)} sx={{ opacity: !confirmTogglePassword ? .3 : 1 }} />}
                        />
                    </article>
                    <article className='col-span-12 flex items-center justify-center gap-4 my-4'>
                        <ButtonOutlined
                            onClick={() => {
                                onClose(false);
                                setErrorMessage("");
                                setFormChangePassword({
                                    password: "",
                                    confirmPassword: ""
                                })
                            }}
                            mode='del'
                            buttonName={t("ยกเลิก")}
                        />
                        <ButtonPrimary
                            disabled={!formChangePassword.password || !formChangePassword.confirmPassword}
                            onClick={() => id && handleSubmit(+id)}
                            mode='success'
                            buttonName={t("ยืนยัน")}
                        />
                    </article>
                </section>
            }
        />
    )
}

export default ModalEditPassword